/*
  UMD header generated via modularize.js at 2015-04-02T22:08:28.119Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/underscore-1.8.2.min': '_'
})(this, function (m_module, Backbone, _) {

var M = m_module.M;

'use strict';

  /**
   * @class M.StorageManager
   *
   * @param {Storage} storage An object implementing the Storage interface
   * http://www.w3.org/TR/webstorage/#the-storage-interface
   */
  M.StorageManager = (function () {
    function StorageManager(storage, options) {
      this.options = _.extend({}, this.defaultOptions, options);
      this.storage = storage;
      this.configuredKeys = {};
      this._length();
    }

    var StorageManagerErrors = {
      QUOTA_EXCEEDED_ERR: 22
    };

    // Standard 30 minutes for a given item to exist then it should be purged
    StorageManager.prototype.mintedSessionExpireTime = 1800; // seconds

    StorageManager.prototype.defaultOptions = {
      // Invalid entries will be purged first. Invalid entries are entries
      // that don't have corresponding expiration data, which is basically any
      // item that was defined before this interface existed.
      invalidExpire: -1,
      // Only purge one item at a time. This ensures that we keep data around
      // for as long as possible, but it may negatively impact performance if
      // we have to clear a lot of small pieces of data to make way for a
      // large piece of data.
      conservativePurge: true,
    };

    StorageManager.localStorage = function (options) {
      var storage;
      options || (options = {});
      var BackupStorage = options.BackupStorage;
      if (!BackupStorage) {
        BackupStorage = StorageManager.Storage;
      }
      //IE 10 throws an exception if we're not permitted to access
      //local storage
      try {
        storage = window.localStorage;
      } catch (e) {}
      if (!storage) {
        storage = new BackupStorage();
      }
      return new StorageManager(storage, options);
    };

    StorageManager.prototype._verifyFormat = function (fullItem) {
      return fullItem &&
        typeof fullItem === 'object' &&
        'value' in fullItem &&
        'expire' in fullItem;
    };

    StorageManager.prototype._getFullItem = function (key) {
      var item = this.storage.getItem(key);
      var parsedItem;
      if (item) {
        try {
          parsedItem = JSON.parse(item);
        } catch (e) {}
      } else {
        parsedItem = {value: null, expire: null};
      }
      if (!this._verifyFormat(parsedItem)) {
        console.warn(key + ' is not properly formatted. Converting format.');
        parsedItem = {
          value: typeof parsedItem !== 'undefined' ? parsedItem : item,
          expire: this._parseExpire(
            this.options.invalidExpire || this.options.defaultExpire)
        };
      }
      return parsedItem;
    };

    /**
     * @param {String} key The key to find the value for
     *
     * @return {*} The JSON-parsed value
     */
    StorageManager.prototype.get = function (key) {
      return this._getFullItem(key).value;
    };
    StorageManager.prototype.getItem = StorageManager.prototype.get;

    StorageManager.prototype._parseExpire = function (expire) {
      var expireDate;
      if (expire) {
        if (expire.getTime) {
          expireDate = expire.getTime();
        } else if (typeof expire === 'number') {
          expireDate = new Date().getTime() + (expire * 1000);
        } else {
          throw new Error('expire must be either a Date or a Number');
        }
      }
      return expireDate;
    };

    StorageManager.prototype.configureKey = function (key, expire) {
      this.configuredKeys[key] = expire;
    };

    /**
     * @param {String} key The key to save the value under
     * @param {Object} value The JSON-encodable value to store
     * @param {Date|Number} expire The date when this key should expire or the
     * number of seconds from now this key should expire
     */
    StorageManager.prototype.set = function (key, value, expire) {
      var expireDate = this._parseExpire(
        expire || this.configuredKeys[key] || this.options.defaultExpire);
      if (expireDate == null) {
        throw new Error('expire is a required argument');
      }
      try {
        this.storage.setItem(key, JSON.stringify({
          expire: expireDate,
          value: value
        }));
        this._length();
      } catch (e) {
        if (e.code === StorageManagerErrors.QUOTA_EXCEEDED_ERR) {
          var didPurge = this.purge();
          // Retry after the purge.
          if (didPurge) {
            this.setItem.apply(this, arguments);
          }
        } else {
          throw e;
        }
      }
    };
    StorageManager.prototype.setItem = StorageManager.prototype.set;

    StorageManager.prototype.remove = function (key) {
      this.storage.removeItem(key);
      this._length();
    };
    StorageManager.prototype.removeItem = StorageManager.prototype.remove;

    StorageManager.prototype.clear = function () {
      this.storage.clear();
      this.length = this.storage.length;
    };

    StorageManager.prototype.purge = function () {
      var now = new Date();
      var didPurge = false;
      for (var i = 0, len = this.length; i < len; i++) {
        var key = this.storage.key(i);
        var item = this._getFullItem(key);
        if (now > item.expire) {
          console.warn('Purging key: ', key);
          this.removeItem(key);
          didPurge = true;
          if (this.options.conservativePurge) {
            break;
          }
        }
      }
      return didPurge;
    };

    _isSameDay = function (date1, date2) {
      date1 = new Date(date1);
      date2 = new Date(date2);
      if ((date1.getDate() == date2.getDate()) &&
          (date1.getMonth() == date2.getMonth()) &&
          (date1.getYear() == date2.getYear())) {
        return true;
      }
      return false;
    };

    StorageManager.prototype.purgeItem = function (key) {
      var now = new Date();
      var didPurge = false;

      var item = this._getFullItem(key);
      if ((now > item.expire) || !_isSameDay(now, item.expire)) {
        _serverLogger.warn('Purging key: ', key);
        this.removeItem(key);
        didPurge = true;
      }
      return didPurge;
    };

    StorageManager.prototype._length = function () {
      return this.length = this.storage.length;
    };

    return StorageManager;
  })();


  /**
   * @class M.StorageManager.Storage
   *
   * A Backbone model with implements the Storage interface with no
   * persistance. Useful for filling in for a true Storage object when there is
   * none available.
   *
   * Can be extended to set up a persistence layer.
   */
  M.StorageManager.Storage = Backbone.Model.extend({
    initialize: function () {
      var onChange = _.bind(function () {
        this._keys = _.keys(this.attributes);
        this.length = this._keys.length;
      }, this);
      this.bind('change', onChange);
      onChange();
    },

    setItem: function (key, value) {
      var o = {};
      o[key] = '' + value;
      this.set(o);
    },

    getItem: function (key) {
      return this.get(key);
    },

    removeItem: function (key) {
      this.unset(key);
    },

    key: function (i) {
      return this._keys[i];
    }
  });


  M.localStorageManager = M.StorageManager.localStorage({
    // By default, data is always ready to expire at the next purge. If data
    // is important, or needs to stick around for a certain amount of time,
    // that information should be explicitly passed to the set function.
    defaultExpire: -1
  });

return {
};

});
